"use client"; // Error boundaries must be Client Components

import { Body, Box, Button, Heading } from "@biom3/react";
import { useEffect } from "react";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error("Application error:", error);
  }, [error]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "base.spacing.x12",
        textAlign: "center",
        height: "70vh",
      }}
    >
      <Heading size="large" weight="bold" sx={{ mb: "base.spacing.x4" }}>
        Something went wrong
      </Heading>
      <Body size="large" sx={{ mb: "base.spacing.x6" }}>
        We're sorry, but there was an error loading this page.
      </Body>
      <Button onClick={() => reset()} variant="primary" type="button">
        Try again
      </Button>
    </Box>
  );
}
